import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from "classnames"
import TextClamp from 'react-string-clamp'

class Header extends Component {

    static propTypes = {
        title: PropTypes.string.isRequired,
        additionnalTitle: PropTypes.string,
        close: PropTypes.func.isRequired,
        className: PropTypes.string.isRequired,
    }

    constructor(props, context) {
        super(props, context)
        this.header = null
    }

    height() {
        return this.header && this.header.offsetHeight
    }

    render() {

        const { title, additionnalTitle, close, className} = this.props

        return (
            <div ref={(header) => this.header = header}>
                <div className={classNames('app-bar-aside-header', className)} >
                    {
                        additionnalTitle ?
                            <div title={additionnalTitle}>
                                <TextClamp
                                    text={additionnalTitle}
                                    lines="3"
                                    className='app-bar-aside-header-additionnal-title'
                                />
                            </div>
                         :
                            <div className='app-bar-aside-header-title'>{title}</div>
                    }
                    <div className="app-bar-close-button" onClick={close}>
                        <span aria-hidden="true">×</span>
                    </div>
                </div>
            </div>
        )
    }
}

export default Header
